// https://ionel-lupu.com/blog/onsticky-event-hook-in-react#:~:text=The%20React%20way%20is%20to,the%20top%20of%20the%20screen.

import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

const BREAKPOINT_WIDTHS = {
  0: 'xs',
  640: 'sm',
  848: 'md',
  1124: 'lg',
  1280: 'xl',
  1536: '2xl',
};

// Pre-sort breakpoint values for better performance
const SORTED_BREAKPOINTS = Object.keys(BREAKPOINT_WIDTHS)
  .map(Number)
  .sort((a, b) => b - a);

export const getBreakpoint = (width) => {
  // Find the first breakpoint that's smaller than the current width
  const breakpointWidth = SORTED_BREAKPOINTS.find((point) => width > point) || 0;
  return BREAKPOINT_WIDTHS[breakpointWidth];
};

export const isMobile = (windowInnerWidth) => {
  return ['xs', 'sm'].includes(getBreakpoint(windowInnerWidth));
};

export const useBreakpoints = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [breakpoint, setBreakpoint] = useState(getBreakpoint(window.innerWidth));

  useEffect(() => {
    const handleResize = debounce(
      () => {
        const width = window.innerWidth;
        const newBreakpoint = getBreakpoint(width);
        // Only update state if values have changed
        if (width !== windowWidth) {
          setWindowWidth(width);
        }
        if (newBreakpoint && newBreakpoint !== breakpoint) {
          setBreakpoint(newBreakpoint);
        }
      },
      100,
      { leading: true, trailing: true }
    ); // 100ms debounce

    // Initial calculation
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      handleResize.cancel(); // Cancel any pending debounced calls
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint, windowWidth]); // Include dependencies to properly handle state updates

  return { windowWidth, breakpoint };
};
